//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmationAppointment from './confirmation/ConfirmationAppointment';
import ConfirmationSelection from './confirmation/ConfirmationSelection';

export default {
    components: {
        ConfirmationAppointment,
        ConfirmationSelection
    },
    props: {
        lang: {
            type: String,
            required: true,
        },
        token: {
            type: String,
            required: true,
        },
        contactUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appointmentConfirmed: false,
            dates: [],
            coffees: [],
        }
    },
    methods: {
        submit()
        {
            this.appointmentConfirmed = true;

            document.documentElement.scrollIntoView({ behavior: 'smooth' })
        },
    },
    created() {
        this.$app.get('axios').get('/api/funnel/slots?lang=' + this.lang ).then( response => {
            this.dates = response.data;
        } );

        this.$app.get('axios').get('/api/funnel/coffees?lang=' + this.lang + '&token=' + this.token ).then( response => {
            this.coffees = response.data;
        } );
    },
}
